import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import Datepicker from '../Inputs/Datepicker'
import InputText from '../Inputs/InputText'
import RawAutoComplete from '../Inputs/RawAutoComplete'

const AdvancedAccountingRecord: React.FC<IAdvancedAccountingRecord> = ({
  onClose,
  onSubmit,
}) => {
  const form = useForm()

  const [selectedAccount, setSelectedAccount] = useState<any>(null)

  const [isDateSelected, setIsDateSelected] = useState<boolean>(false)

  const onSubmitForm = (values) => {
    if (selectedAccount) {
      onSubmit({ ...values, accountId: selectedAccount?.id })
      return
    }

    onSubmit(values)
  }

  return (
    <Form
      form={form}
      onSubmit={(values) => onSubmitForm({ ...values, isDateSelected })}
      classes="gap-x-2 p-2"
    >
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere">
        Búsqueda avanzada
      </label>

      <FormItem name="username" classes="xl:col-span-6 col-span-12">
        <InputText small label="Usuario" maxLength={80} isUpperValue={false} />
      </FormItem>

      <FormItem name="description" classes="xl:col-span-6 col-span-12">
        <InputText
          small
          label="Descripción"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      <FormItem
        name="name"
        classes="xl:col-span-6 col-span-12"
        rules={{ required: 'Es necesario una cuenta contable' }}
      >
        {/* <InputText label="Emisor" /> */}
        <RawAutoComplete
          label="Cuenta contable"
          url={`accounting/simple-search`}
          bodyGet={'accounts'}
          queryParam={'search'}
          selectedValue={undefined}
          setSelectedValue={(value) => {
            console.log('value..', value)
            setSelectedAccount(value)
          }}
        />
      </FormItem>

      <div
        className="xl:col-span-6 col-span-12 mt-1 xl:row-start-4"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="fromDate"
          classes="xl:col-span-6 col-span-12 mt-1 xl:row-start-4"
          rules={{
            required: 'Debe especificar la fecha',
          }}
        >
          <Datepicker label="Fecha desde" />
        </FormItem>
      </div>

      <div
        className="xl:col-span-6 col-span-12 mt-1 xl:row-start-4"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="toDate"
          classes="xl:col-span-6 col-span-12 mt-1 xl:row-start-4"
          rules={{
            required: 'Debe especificar la fecha',
          }}
        >
          <Datepicker label="Fecha hasta" />
        </FormItem>
      </div>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedAccountingRecord {
  onClose: () => void
  onSubmit: (values) => void
}

export default AdvancedAccountingRecord
